export default {"src":"/_next/static/media/turntable.8eded0cf.svg","height":173,"width":382,"blurWidth":0,"blurHeight":0};